// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCnXsjj53Vn7N6ptfZepKUAs-yUBK4w2pI",
  authDomain: "cntndr-3a1a2.firebaseapp.com",
  projectId: "cntndr-3a1a2",
  storageBucket: "cntndr-3a1a2.appspot.com",
  messagingSenderId: "440313001813",
  appId: "1:440313001813:web:ab82dcfb7dd0070daea1dc",
  measurementId: "G-ZJBVKCDMHC"
};

// Initialize Firebase

// const auth = firebase.auth();
// const firestore = firebase.firestore();

// export { auth, firestore};